import Progress from './Progress.vue';
export default Progress;
